/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const VARIANTS = {
    16: {
        viewBox: '0 0 16 16',
        path: 'M3.05263 4.27337L7.9605 9.07625L12.9535 4.27188C13.6569 3.4809 15.4015 4.56085 14.3242 5.65477L7.9605 12L1.67401 5.65477C0.672499 4.70075 2.10749 3.47296 3.05263 4.27337Z',
        fillPath: true,
    },
    20: {
        viewBox: '0 0 20 20',
        path: 'M3.81542 5.34171L9.95026 11.3453L16.1915 5.33985C17.0708 4.35113 19.2516 5.70106 17.9049 7.06847L9.95026 15L2.09215 7.06847C0.840257 5.87593 2.634 4.3412 3.81542 5.34171Z',
        fillPath: true,
    },
};

export const ChevronIcon = ({ direction, size }) => {
    const { viewBox, path, fillPath } = VARIANTS[size];

    return (
        <svg
            width={size}
            height={size}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: direction === 'up' ? 'rotate(180deg)' : 'none', flexShrink: 0 }}
        >
            <path
                d={path}
                {...(fillPath
                    ? { fill: 'currentColor', fillRule: 'evenodd', clipRule: 'evenodd' }
                    : { stroke: 'currentColor', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }
                )}
            />
        </svg>
    );
};

ChevronIcon.propTypes = {
    direction: PropTypes.oneOf(['up', 'down']),
    size: PropTypes.oneOf([16, 20]),
};

ChevronIcon.defaultProps = {
    direction: 'down',
    size: 20,
};
